"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-4064581d"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "oplus-table-wrapper" };
const _hoisted_2 = { class: "oplus-table oplus-table-hover" };
const _hoisted_3 = { class: "row-sticky" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", {
    class: "role-section-edit-cell",
    rowspan: "2"
}, "編集", -1 /* HOISTED */));
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", {
    class: "role-section-name-cell",
    rowspan: "2"
}, "業務名", -1 /* HOISTED */));
const _hoisted_6 = {
    key: 0,
    class: "role-section-edit-cell"
};
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "role-section-edit-cell" }, "休憩", -1 /* HOISTED */));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", { class: "role-section-edit-cell" }, "シフト表に表示", -1 /* HOISTED */));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("th", {
    class: "delete-btn-cell role-section-edit-cell",
    rowspan: "2"
}, null, -1 /* HOISTED */));
const _hoisted_10 = { href: "#" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = { class: "roles-name-cell" };
const _hoisted_13 = {
    key: 0,
    class: "flex-center tooltip tooltip-right mr-1",
    "data-tooltip": "他拠点に同期済み"
};
const _hoisted_14 = { class: "text-ellipsis section-label" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = {
    key: 0,
    class: "zmdi zmdi-check zmdi-hc-lg text-success"
};
const _hoisted_17 = {
    key: 1,
    class: "zmdi zmdi-close zmdi-hc-lg text-error"
};
const _hoisted_18 = {
    key: 0,
    class: "zmdi zmdi-check zmdi-hc-lg text-success"
};
const _hoisted_19 = {
    key: 1,
    class: "zmdi zmdi-close zmdi-hc-lg text-error"
};
const _hoisted_20 = { class: "delete-btn-cell" };
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const KebabMenuIcon_vue_1 = __importDefault(require("../../vue/icons/KebabMenuIcon.vue"));
const DeleteIcon_vue_1 = __importDefault(require("../../vue/icons/DeleteIcon.vue"));
const EditIcon_vue_1 = __importDefault(require("../../vue/icons/EditIcon.vue"));
const GroupSectionIcon_vue_1 = __importDefault(require("../../vue/icons/GroupSectionIcon.vue"));
const BranchTallIcon_vue_1 = __importDefault(require("../../view/assets/icons/BranchTallIcon.vue"));
const vue_3 = require("vue");
const common_1 = require("../../js/common");
const roleSectionInjectionKeys_1 = require("../types/roleSectionInjectionKeys");
const roles_1 = require("../../js/roles");
const provider_1 = require("../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleSectionTable',
    props: {
        isRoleSectionTableLoading: Boolean,
    },
    emits: ["role-section-on-delete", "role-section-on-edit"],
    setup(__props, { emit: __emit }) {
        const roleSectionArray = (0, vue_3.inject)(roleSectionInjectionKeys_1.RoleSectionArray) || [];
        const isGroupSectionPage = (0, vue_3.inject)(roleSectionInjectionKeys_1.GroupRoleSectionInjectionKey, false);
        const { openGroupRoleBranchModal } = (0, vue_3.inject)(roleSectionInjectionKeys_1.GroupRoleSectionViewInjectionKey, { openGroupRoleBranchModal: () => { }, setNewGroupRoleBranch: () => { } });
        const groupRoleBranchViewModel = (0, vue_3.inject)(provider_1.groupRoleBranchViewModelInjectKey, undefined);
        const props = __props;
        const emitToContent = __emit;
        const data = (0, vue_3.ref)({
            selectedRoleId: "",
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return {
                "loading": props.isRoleSectionTableLoading
            };
        });
        // unused functions for now at the moment
        // ** start **
        function roleStartTime(role) {
            const startHour = (0, common_1.addZeroPlaceholders)(role.getStartHour());
            const startMinute = (0, common_1.addZeroPlaceholders)(role.getStartMinute());
            return `${startHour}:${startMinute}`;
        }
        function roleEndTime(role) {
            const endHour = (0, common_1.addZeroPlaceholders)(role.getEndHour());
            const endMinute = (0, common_1.addZeroPlaceholders)(role.getEndMinute());
            return `${endHour}:${endMinute}`;
        }
        function renderRoleLabel(role) {
            const startTime = roleStartTime(role);
            const endTime = roleEndTime(role);
            return `${startTime} ~ ${endTime}`;
        }
        // ** end **
        function showEditPopup(roleId) {
            data.value.selectedRoleId = roleId;
        }
        function closeEditPopup() {
            data.value.selectedRoleId = "";
        }
        function handleRoleSectionDelete(roleId) {
            (0, roles_1.openConfirmModal)("割り当てている全ての業務から削除されますが、よろしいですか？", () => {
                emitToContent('role-section-on-delete', roleId);
            });
        }
        function handleRoleSectionEdit(roleId) {
            emitToContent('role-section-on-edit', roleId);
        }
        function roleColor(role) {
            return {
                'color': role.color ? "#fff" : "",
                'background-color': role.color ? `#${role.color}` : "",
                'border-radius': "3px",
            };
        }
        function groupSectionColor(role) {
            return {
                'color': role.color ? "#fff" : "#4693c2",
            };
        }
        function getActiveBranchCountLabel(role) {
            return groupRoleBranchViewModel?.value.activeBranchCounts?.get(role.getOriginalId()) || '';
        }
        (0, vue_3.onMounted)(() => {
            document.addEventListener('click', closeEditPopup);
        });
        (0, vue_3.onBeforeUnmount)(() => {
            document.removeEventListener('click', closeEditPopup);
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createCommentVNode)(" Role Sections List "),
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("table", _hoisted_2, [
                        (0, vue_2.createElementVNode)("thead", null, [
                            (0, vue_2.createElementVNode)("tr", _hoisted_3, [
                                _hoisted_4,
                                _hoisted_5,
                                ((0, vue_2.unref)(isGroupSectionPage))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("th", _hoisted_6, "使用中の拠点数"))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                _hoisted_7,
                                _hoisted_8,
                                _hoisted_9
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("tbody", null, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(roleSectionArray), (role) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                    key: role.getId()
                                }, [
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("a", _hoisted_10, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: "svg-container oplus-icon",
                                                onClick: ($event) => (handleRoleSectionEdit(role.getId()))
                                            }, [
                                                (0, vue_2.createVNode)(EditIcon_vue_1.default)
                                            ], 8 /* PROPS */, _hoisted_11)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: "role-name text-popup flex-center px-2",
                                                style: (0, vue_2.normalizeStyle)(roleColor(role))
                                            }, [
                                                (role.isGroupRole)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                                                        (0, vue_2.createVNode)(GroupSectionIcon_vue_1.default, {
                                                            class: "role-group-star-icon",
                                                            style: (0, vue_2.normalizeStyle)(groupSectionColor(role))
                                                        }, null, 8 /* PROPS */, ["style"])
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                                (0, vue_2.createElementVNode)("span", _hoisted_14, (0, vue_2.toDisplayString)(role.getName()), 1 /* TEXT */)
                                            ], 4 /* STYLE */)
                                        ])
                                    ]),
                                    ((0, vue_2.unref)(isGroupSectionPage))
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_15, (0, vue_2.toDisplayString)(getActiveBranchCountLabel(role)), 1 /* TEXT */))
                                        : (0, vue_2.createCommentVNode)("v-if", true),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (role.isRestSection)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_16))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_17))
                                    ]),
                                    (0, vue_2.createElementVNode)("td", null, [
                                        (role.showCount)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_18))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_19))
                                    ]),
                                    (0, vue_2.createCommentVNode)(" 3 dots button "),
                                    (0, vue_2.createElementVNode)("td", _hoisted_20, [
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("div", {
                                            class: (0, vue_2.normalizeClass)(["edit-section-container svg-container", loadingClass.value]),
                                            onClick: _cache[0] || (_cache[0] = (0, vue_2.withModifiers)(() => { }, ["stop"]))
                                        }, [
                                            (0, vue_2.createElementVNode)("div", {
                                                onClick: ($event) => (handleRoleSectionDelete(role.getId()))
                                            }, [
                                                (0, vue_2.createVNode)(DeleteIcon_vue_1.default, { class: "delete-icon delete-role-icon oplus-icon" })
                                            ], 8 /* PROPS */, _hoisted_21),
                                            ((0, vue_2.unref)(isGroupSectionPage))
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                    key: 0,
                                                    class: "oplus-icon d-flex pr-1",
                                                    onClick: ($event) => ((0, vue_2.unref)(openGroupRoleBranchModal)(role.getOriginalId()))
                                                }, [
                                                    (0, vue_2.createVNode)(BranchTallIcon_vue_1.default, { class: "section-branch-icon" })
                                                ], 8 /* PROPS */, _hoisted_22))
                                                : (0, vue_2.createCommentVNode)("v-if", true)
                                        ], 2 /* CLASS */), [
                                            [vue_2.vShow, role.getId() === data.value.selectedRoleId]
                                        ]),
                                        (0, vue_2.createElementVNode)("div", {
                                            class: "svg-container oplus-icon",
                                            onClick: (0, vue_2.withModifiers)(($event) => (showEditPopup(role.getId())), ["stop"])
                                        }, [
                                            (0, vue_2.createVNode)(KebabMenuIcon_vue_1.default)
                                        ], 8 /* PROPS */, _hoisted_23)
                                    ])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */));
        };
    }
});
